import { ITaskBlock } from 'shared/express-interface/blocks-core/ITaskBlock'
import './ConversationTaskv2UI.less'
import React from 'react'

export type ConversationsTaskv2UIPropsType = {
    blocks: ITaskBlock[]
}

export const ConversationsTaskv2UI = (props: ConversationsTaskv2UIPropsType) => {
    return (
        <div className="conversations-container" data-testid="generation-task-ui-wrapper">
            {props.blocks.map((block, index) => (
                <React.Fragment key={index}>{block.getElement()?.element}</React.Fragment>
            ))}
        </div>
    )
}
